<template>
	<div class="market-watch-container">
		<div v-for="item in watches" class="watch-item">
			<h3>{{item.Title}}</h3>
			<p class="date">{{formatDate(item.Date)}}</p>
			<div class="watch-copy" v-html="item.Description"></div>
			<ul class="watch-data">
				<li>
					<h4>Activity</h4>
					<span>{{item.Activity}}</span>
				</li>
				<li>
					<h4>Prices</h4>
					<span>{{item.Prices}}</span>
				</li>
				<li>
					<h4>Trend</h4>
					<span>{{item.Trend}}</span>
				</li>
				<li>
					<h4>Order Files</h4>
					<span>{{item.OrderFiles}}</span>
				</li>
			</ul>
		</div>
		<button class="btn" v-if="buttonShow" v-on:click="addItems()">View More</button>
	</div>
</template>

<script>
	import DateFormatService from '../../common/date-format.service';
	import MarketWatchService from './market-watch.service';

	export default {
		props: {
		},

		data: function () {
			return {
				watches: {},
				watchpager: {},
				page: 1,
				buttonShow: true
			}
		},
		mounted() {
			this.watches = window.watches != null ? window.watches : [];
			this.watchpager = window.watchpager != null ? window.watchpager : [];

			if (this.watchpager.TotalItems <= 5) {
				this.buttonShow = false;
			}
		},
		methods: {
			addItems() {
				this.page++;

				// get next set of watches
				MarketWatchService.getWatches(this.page).then(response => {
					this.watches = this.watches.concat(response.Items);
					console.log(response);
					if (response.Pager.CurrentPage <= response.Pager.TotalPages) {
						this.buttonShow = false;
					}
				});
			}, 
			formatDate: function (date) {
				return DateFormatService.customFormatter(date, 'full-slash');
			}
        }
    }
</script>